import type { MapStateToProps, MapDispatchToProps } from 'types/redux';
import type {
  ScrollableEditorStageDispatchProps,
  ScrollableEditorStageStateProps,
  ScrollableEditorStageOwnProps,
} from './scrollableEditorStage.types';
import { EditorUIApiKey, FixedStageApiKey } from '#packages/apis';

export const mapStateToProps: MapStateToProps<
  ScrollableEditorStageStateProps,
  ScrollableEditorStageOwnProps
> = ({ state: editorState, editorAPI }) => {
  const { scrollTo, animateScrollTo } = editorState;

  const isPagesPanelOpen = editorAPI.panelHelpers?.isPagesPanelOpen() ?? false;

  const isTruncated = editorAPI.host
    .getAPI(EditorUIApiKey)
    .stage.shouldCutEditingArea();

  const isStageFixedInDesktop = editorAPI.host
    .getAPI(FixedStageApiKey)
    .isStageFixedInDesktop();

  const isStageInZoomMode = editorAPI.zoomMode.isStageZoomMode();

  return {
    isScrollingEnabled: editorAPI.scroll.isEnabled(),
    scrollTo,
    animateScrollTo,
    isPagesPanelOpen,
    isTruncated,
    isStageFixedInDesktop,
    isStageInZoomMode,
  };
};

const getEditorAPI = (
  dispatch: AnyFixMe,
  getState: AnyFixMe,
  { editorAPI }: AnyFixMe,
) => ({
  editorAPI,
  state: getState(),
});

export const mapDispatchToProps: MapDispatchToProps<
  ScrollableEditorStageDispatchProps,
  ScrollableEditorStageOwnProps
> = (dispatch) => {
  const { editorAPI } = dispatch(getEditorAPI);

  return {
    clearScrollTo: () => editorAPI.scroll.clearScrollTo(),
    registerNewScrollPosition(newScrollPosition) {
      return editorAPI.scroll.registerNewScrollPosition(newScrollPosition);
    },
    handleStageScroll: (event) => {
      // TODO: refactor it
      if (editorAPI.scroll.handleStageScroll) {
        editorAPI.scroll.handleStageScroll(event);
      }
    },
  };
};
